export const EXPIRED_SESSION_TOKEN = 'EXPIRED_SESSION_TOKEN';
export const getopenSessionToken = (data) => {
    return {
        type: EXPIRED_SESSION_TOKEN,
        payload: data
    }
}